import { Avatar, AvatarFallback, AvatarImage } from '@mxa-argos/components/shadcn/avatar';
import { cn } from '@mxa-argos/lib/utils';

const AVATAR_SIZE_STYLES = {
  xs: { avatar: 'size-4', fallback: 'text-[8px]' },
  sm: { avatar: 'size-5', fallback: 'text-[10px]' },
  md: { avatar: 'size-6', fallback: 'text-xs' },
  lg: { avatar: 'size-7', fallback: 'text-xs' },
  xl: { avatar: 'size-8', fallback: 'text-sm' },
} as const;

interface UserAvatarProps {
  name?: string | null;
  pictureURL?: string | null;
  size?: keyof typeof AVATAR_SIZE_STYLES;
  className?: string;
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .slice(0, 2)
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase();
}

export function UserAvatar({ name, pictureURL, size = 'md', className }: UserAvatarProps) {
  const displayName = name ?? '?';
  const sizeStyles = AVATAR_SIZE_STYLES[size];

  return (
    <Avatar className={cn(sizeStyles.avatar, 'shrink-0', className)}>
      {pictureURL && <AvatarImage src={pictureURL} alt={displayName} />}
      <AvatarFallback
        className={cn('bg-primary text-primary-foreground font-medium', sizeStyles.fallback)}
      >
        {getInitials(displayName)}
      </AvatarFallback>
    </Avatar>
  );
}
